import { resolveEnv } from '@/utils/sentry';

/**
 * QA only: open the app with `?qa_crash=1` to crash the render on purpose and
 * test the crash screen + "Report the problem" feedback end to end. Renders
 * nothing — and never reads the URL — outside the QA build.
 */
export default function QaCrashTrigger() {
  if (resolveEnv().environment !== 'qa') return null;
  if (new URLSearchParams(window.location.search).get('qa_crash') === '1') {
    throw new Error('QA crash test');
  }
  return null;
}
